import React from 'react';
import ExecJob from './ExecJob/ExecJob';
import ExportSetting from './ExportSetting/ExportSetting';
import DownloadJson from './DownloadJson/DownloadJson';

import './WizardSummary.scss';
import { camelCaseToSpacedString, getSafe } from '../../../shared/utility';
import {
  TEST_CONFIG_DYNAMIC_FIELDS,
  TEST_CONFIG_FIELDS,
  TEST_CONFIG_FUSES,
  TEST_CONFIG_STRAPS,
} from '../../../shared/const/Routes/statePaths';
import { useSelector } from 'react-redux';
import {
  FUSE_EDIT_TABLE,
  STRAP_EDIT_TABLE,
} from '../../../shared/const/GenericTableParams/TestConfigurationTables';

const PAGE_TITLE = 'Please select an option';

const WizardSummary = props => {
  const staticFields = useSelector(state => getSafe(TEST_CONFIG_FIELDS, state));
  const dynamicFields = useSelector(state =>
    getSafe(TEST_CONFIG_DYNAMIC_FIELDS, state)
  );
  const fuses = useSelector(state => getSafe(TEST_CONFIG_FUSES, state));
  const straps = useSelector(state => getSafe(TEST_CONFIG_STRAPS, state));

  const renderEditTableRows = (selector, metadata) => {
    const toRender = selector.filter(
      row =>
        row[metadata.editColumnName] != row[metadata.defaultValueColumnName]
    );
    if (toRender.length <= 0) {
      return null;
    }
    return (
      <div className="category-wrapper">
        <label className="category-title">{metadata.tableName}</label>
        {toRender.map(row => {
          return (
            <label className="category-field">
              {camelCaseToSpacedString(row[metadata.searchColumnName])}:{' '}
              {row[metadata.editColumnName]}
            </label>
          );
        })}
      </div>
    );
  };

  const renderCategories = selector => {
    return Object.keys(selector).map(category => {
      return (
        <div className="category-wrapper">
          <label className="category-title">
            {camelCaseToSpacedString(category)}
          </label>
          {Object.keys(selector[category]).map(field => {
            const isNotNull =
              'value' in selector[category][field] &&
              selector[category][field].value != '' &&
              selector[category][field].value != null;
            let value = 'None';
            if (selector[category][field].value === false) {
              value = 'False';
            } else if (selector[category][field].value === true) {
              value = 'True';
            } else if (isNotNull) {
              value = selector[category][field].value;
            }
            if (Array.isArray(value)) {
              return (
                <div className="flex-row margin-right-small">
                  <label className="category-field">
                    {camelCaseToSpacedString(field)}:
                  </label>
                  <div className="flex-column">
                    {value.map(line => (
                      <label>-{line}</label>
                    ))}
                  </div>
                </div>
              );
            } else {
              return (
                <label className="category-field label-ellipsis2" title={value}>
                  {camelCaseToSpacedString(field)}: {value}
                </label>
              );
            }
          })}
        </div>
      );
    });
  };

  const renderDynamicCategories = selector => {
    return Object.keys(selector).map(category => {
      let myCategory = selector[category];
      let myFields = myCategory.testFields;
      return (
        <div className="category-wrapper">
          <label className="category-title">
            {myCategory.categoryDescription}
          </label>
          {Object.keys(myFields).map(field => {
            const isNotNull =
              'value' in myFields[field] &&
              myFields[field].value != '' &&
              myFields[field].value != null;
            let value = 'None';
            if (myFields[field].value === false) {
              value = 'False';
            } else if (myFields[field].value === true) {
              value = 'True';
            } else if (isNotNull) {
              value = myFields[field].value;
            }
            if (Array.isArray(value)) {
              return (
                <div className="flex-row margin-right-small">
                  <label className="category-field">
                    {myFields[field].fieldDescription
                      ? myFields[field].fieldDescription
                      : myFields[field].fieldName}
                    :
                  </label>
                  <div className="flex-column">
                    {value.map(line => (
                      <label>-{line}</label>
                    ))}
                  </div>
                </div>
              );
            } else {
              return (
                <label className="category-field label-ellipsis2" title={value}>
                  {myFields[field].fieldDescription
                    ? myFields[field].fieldDescription
                    : myFields[field].fieldName}
                  : {value}
                </label>
              );
            }
          })}
        </div>
      );
    });
  };

  return (
    <>
      {/* {isLoading && showStatus()} */}
      <label className="project-sub-title wizard-summary-title">Summary</label>
      <div className="summary-container">
        <div className="expander-container">
          {/* <PackageDetail viewType={props.type} /> */}
          {/* <div className="details-block-header"> */}
          <label className="expander-header">SUMMARY</label>
          {/* </div> */}
          <div className="expander-content">
            {renderCategories(staticFields)}
            {renderEditTableRows(fuses, FUSE_EDIT_TABLE)}
            {renderEditTableRows(straps, STRAP_EDIT_TABLE)}
            {renderDynamicCategories(dynamicFields)}
          </div>
        </div>
        <div className="summary-button-container">
          <div className="sub-title stage-zero-title"> {PAGE_TITLE} </div>
          <div className="stage-zero-btns-area">
            <ExecJob></ExecJob>
            <ExportSetting></ExportSetting>
            <DownloadJson></DownloadJson>
          </div>
        </div>
      </div>
    </>
  );
};

export default WizardSummary;
